import {gql} from "@irati/utils/gql"
import fullInternalUser from "../fragments/fullInternalUser"
import fullInternalProductPermissions from "../fragments/internalProductPermissions"

const query = gql`
  query ResumeInternal($email: String!) {
    user: internalAdminUser(email: $email) {
      ...fullInternalUser
    }
    productPermissions {
      ...fullInternalProductPermissions
    }
  }
  ${fullInternalUser}
  ${fullInternalProductPermissions}
`

export const toString = query.loc.source.body

export default query
